import { connect } from 'react-redux';
import Confirm from './Confirm';

const mapStateToProps = (state: any) => ({
  messages: state.confirmation.messages,
  name: state.confirmation.name,
  applyBtnAppearance: state.confirmation.applyBtnAppearance,
  applyBtnText: state.confirmation.applyBtnText,
  title: state.confirmation.title,
  onSubmit: state.confirmation.onSubmit,
  onCancel: state.confirmation.onCancel,
  onError: state.confirmation.onError,
  cancelBtnText: state.confirmation.cancelBtnText,
  asyncAction: state.confirmation.asyncAction,
});

export default connect(mapStateToProps, null)(Confirm as any);
